import { StyleSheet } from 'react-native';

const QAAnswer2Image = ({ style }) => {
  const oneX = require('./AlittleBit.jpg');
  const twoX = require('./AlittleBit@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'contain' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { QAAnswer2Image };
